import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';

const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Define navigation links
  const navLinks = [
    { to: "/", text: "Home" },
    { to: "/salvation", text: "Salvation" },
    { to: "/hymns", text: "Hymns" },
    { to: "/armor-of-god", text: "Armor of God" },
    { to: "/safety-verses", text: "Safety Team" }, // Changed text to "Safety Team"
    { to: "/about", text: "About" }
  ];

  // Close mobile menu on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960 && mobileMenuOpen) {
        setMobileMenuOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileMenuOpen]);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = !mobileMenuOpen ? 'hidden' : 'auto';
  };

  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <Link to="/" className={styles.navbarLogo} onClick={closeMobileMenu}>
          Christ Centered Baptist
        </Link>
        
        <div className={styles.mobileMenuButton} onClick={toggleMobileMenu}>
          {mobileMenuOpen ? '✕' : '☰'}
        </div>
        
        {/* Desktop Navigation */}
        <ul className={styles.navMenu}>
          {navLinks.map((link, index) => (
            <li key={index} className={styles.navItem}>
              <Link to={link.to} className={styles.navLink}>
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
        
        {/* Mobile Navigation Overlay */}
        {mobileMenuOpen && (
          <div className={styles.mobileNavOverlay}>
            <ul className={styles.mobileNavMenu}>
              {navLinks.map((link, index) => (
                <li key={index} className={styles.mobileNavItem}>
                  <Link
                    to={link.to}
                    className={styles.mobileNavLink}
                    onClick={closeMobileMenu}
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
